import { Paper, Stack, Typography } from '@mui/material'
import { WorkflowAppLogo } from '@/components/ConnectionApps/WorkflowAppLogo/WorkflowAppLogo.jsx'
import styles from './integrationsModal.module.scss'

/**
 * @param {{ app: { slug: string, title: string, description: string, icon?: string } }} props
 */
export default function IntegrationCard({ app }) {
  return (
    <Paper elevation={0} className={styles.integrationCard}>
      <Stack direction="row" spacing={1.5} alignItems="center" className={styles.integrationCardInner}>
        <WorkflowAppLogo
          variant="integration"
          iconUrl={app.icon}
          pillKind={app.slug}
          displayName={app.title}
        />
        <Stack spacing={0.25} className={styles.integrationCardText}>
          <Typography component="h4" className={styles.integrationCardTitle}>
            {app.title}
          </Typography>
          <Typography component="p" className={styles.integrationCardDescription}>
            {app.description}
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  )
}
